var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4688 31.5H32.4844V17.5547C32.4844 11.7674 28.2064 6.98496 22.6406 6.18926V4.59375C22.6406 3.6873 21.9064 2.95312 21 2.95312C20.0936 2.95312 19.3594 3.6873 19.3594 4.59375V6.18926C13.7936 6.98496 9.51562 11.7674 9.51562 17.5547V31.5H8.53125C7.80527 31.5 7.21875 32.0865 7.21875 32.8125V34.125C7.21875 34.3055 7.36641 34.4531 7.54688 34.4531H16.4062C16.4062 36.9879 18.4652 39.0469 21 39.0469C23.5348 39.0469 25.5938 36.9879 25.5938 34.4531H34.4531C34.6336 34.4531 34.7812 34.3055 34.7812 34.125V32.8125C34.7812 32.0865 34.1947 31.5 33.4688 31.5ZM21 36.4219C19.9131 36.4219 19.0312 35.54 19.0312 34.4531H22.9688C22.9688 35.54 22.0869 36.4219 21 36.4219ZM12.4688 31.5V17.5547C12.4688 15.2742 13.3547 13.1332 14.9666 11.5213C16.5785 9.90937 18.7195 9.02344 21 9.02344C23.2805 9.02344 25.4215 9.90937 27.0334 11.5213C28.6453 13.1332 29.5312 15.2742 29.5312 17.5547V31.5H12.4688Z",
    fill: "#845BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7d6b91772df956dc863f48d359fdaccd.svg";
export { ForwardRef as ReactComponent };